function clampNumber(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function createDebounced(fn, delayMs) {
  var timeoutId = null;
  return function () {
    var args = arguments;
    if (timeoutId) window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(function () {
      timeoutId = null;
      fn.apply(null, args);
    }, delayMs);
  };
}

function ensureTrack(paginationEl) {
  var existing = paginationEl.querySelector(':scope > .swiper-pagination__track');
  if (existing) return existing;

  var track = document.createElement('div');
  track.className = 'swiper-pagination__track';

  // Move bullets (and any other pagination children) into the track.
  while (paginationEl.firstChild) {
    track.appendChild(paginationEl.firstChild);
  }
  paginationEl.appendChild(track);
  return track;
}

function computeBulletMetrics(bullets) {
  if (!bullets || bullets.length === 0) return null;

  var firstRect = bullets[0].getBoundingClientRect();
  if (!firstRect || firstRect.width <= 0) return null;

  var width = firstRect.width;

  if (bullets.length < 2) {
    return { width: width, gap: 0 };
  }

  var secondRect = bullets[1].getBoundingClientRect();
  var gap = Math.max(0, Math.round(secondRect.left - firstRect.right));

  return { width: width, gap: gap };
}

function setWindowStyles(paginationEl, trackEl, bulletWidth, gap, visible) {
  paginationEl.style.display = 'flex';
  paginationEl.style.flexWrap = 'nowrap';
  paginationEl.style.justifyContent = 'flex-start';
  paginationEl.style.alignItems = 'center';
  paginationEl.style.overflow = 'hidden';

  var windowWidth = visible * bulletWidth + Math.max(0, visible - 1) * gap;
  paginationEl.style.width = windowWidth + 'px';

  trackEl.style.display = 'flex';
  trackEl.style.flexWrap = 'nowrap';
  trackEl.style.alignItems = 'center';
  trackEl.style.justifyContent = 'flex-start';
  trackEl.style.gap = gap + 'px';
  trackEl.style.willChange = 'transform';
  trackEl.style.transition = 'transform 200ms ease';
}

function normalizeBulletMargins(bullets) {
  if (!bullets) return;
  for (var i = 0; i < bullets.length; i++) {
    bullets[i].style.margin = '0';
  }
}

function getActiveIndex(swiper) {
  if (!swiper) return 0;
  // loop is false in these sliders; activeIndex is safe.
  return typeof swiper.activeIndex === 'number' ? swiper.activeIndex : 0;
}

function updateTrackPosition(swiper, trackEl, bulletStep, visible) {
  if (!swiper || !trackEl) return;
  var bullets = swiper.pagination && swiper.pagination.bullets;
  if (!bullets || bullets.length <= visible) {
    trackEl.style.transform = 'translate3d(0, 0, 0)';
    return;
  }

  var active = getActiveIndex(swiper);
  var maxStart = bullets.length - visible;
  var start = clampNumber(active - (visible - 1), 0, maxStart);
  var x = -start * bulletStep;
  trackEl.style.transform = 'translate3d(' + x + 'px, 0, 0)';
}

export function setupSwiperPaginationWindow(swiper, options) {
  if (!swiper || !swiper.pagination || !swiper.pagination.el || !swiper.pagination.bullets) return;

  var visible = (options && options.visible) || 5;
  var paginationEl = swiper.pagination.el;

  var compute = function () {
    var bullets = swiper.pagination && swiper.pagination.bullets;
    if (!bullets || bullets.length === 0) return;

    var trackEl = ensureTrack(paginationEl);

    // Reset any previously forced width if there are few bullets.
    if (bullets.length <= visible) {
      paginationEl.style.width = '';
      paginationEl.style.overflow = '';
      trackEl.style.transform = 'translate3d(0, 0, 0)';
      return;
    }

    // Measure before normalizing margins so we can preserve the visual gap.
    var metrics = computeBulletMetrics(bullets);
    if (!metrics) return;

    normalizeBulletMargins(bullets);
    setWindowStyles(paginationEl, trackEl, metrics.width, metrics.gap, visible);
    updateTrackPosition(swiper, trackEl, metrics.width + metrics.gap, visible);
  };

  // Wait for Swiper to render bullets and for layout to settle.
  if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(compute);
    });
  } else {
    compute();
  }

  if (swiper.on) {
    swiper.on('slideChange', function () {
      compute();
    });
    swiper.on('paginationUpdate', function () {
      compute();
    });
  }

  if (typeof window !== 'undefined' && 'ResizeObserver' in window) {
    var ro = new ResizeObserver(createDebounced(compute, 50));
    ro.observe(paginationEl);
    if (swiper.on) {
      swiper.on('destroy', function () {
        ro.disconnect();
      });
    }
  } else if (typeof window !== 'undefined') {
    var onResize = createDebounced(compute, 100);
    window.addEventListener('resize', onResize, { passive: true });
    if (swiper.on) {
      swiper.on('destroy', function () {
        window.removeEventListener('resize', onResize);
      });
    }
  }
}

